<template>
  <div>
    <b-input
      :placeholder="placeholderSearch"
      hide-details
      readonly
      rounded="lg"
      @click="dialog = true">
      <template #prepend-inner>
        <v-icon color="grey">mdi-magnify</v-icon>
      </template>
    </b-input>
    <v-dialog
      v-model="dialog"
      :close-on-click-modal="false"
      absolute
      attach="body"
      content-class="dialog-top"
      scrim="#000000b0">
      <v-card rounded="lg">
        <v-card-text>
          <b-input
            v-model="searchQuery"
            :loading="$loading.isLoading('globalSearch')"
            clearable
            hide-details
            placeholder="Пошук документів, завдань, контрагентів..."
            variant="outlined"
            @keydown.enter.prevent="onEnter">
            <template #append>
              <v-btn
                :loading="$loading.isLoading('globalSearch')"
                class="font-weight-bold text-capitalize"
                color="grey-lighten-3"
                @click.stop="onEnter()">
                <div class="d-flex align-center gap-2">
                  <span>Пошук</span>
                  <v-icon>mdi-magnify</v-icon>
                </div>
              </v-btn>
            </template>
          </b-input>
          <v-divider class="my-2"></v-divider>
          <v-chip-group column multiple>
            <v-chip
              v-for="tag in searchTags"
              :key="tag.value"
              :class="{ 'chip-error': v$.selectedTags.$error }"
              :text-color="selectedTags.includes(tag.value) ? 'white' : 'black'"
              @click="toggleTag(tag.value)">
              {{ tag.title }}
              <v-icon
                v-if="selectedTags.includes(tag.value)"
                class="ml-1"
                small
                @click.stop="removeTag(tag.value)">
                mdi-close
              </v-icon>
            </v-chip>
          </v-chip-group>
          <p v-if="v$.selectedTags.$error" class="text-error text-caption mt-1">
            Оберіть хоча б один тип для пошуку
          </p>
          <search-list></search-list>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import { ref } from 'vue'
import { initGlobalSearch } from '@/components/the-header/global-search/index'
import SearchList from './SearchList.vue'
import { getErrorMessages } from 'best-modules/utils'

export default {
  name: 'GlobalSearch',
  components: { SearchList },
  methods: { getErrorMessages },
  setup() {
    const dialog = ref(false)
    const globalSearchStore = initGlobalSearch()

    return {
      dialog,
      ...globalSearchStore,
    }
  },
}
</script>

<style lang="scss">
.dialog-top {
  top: -10px !important;
  position: absolute !important;
  transform: none !important;
  left: 220px;
  width: 55% !important;
}
.chip-error {
  border: 1px solid #f5acac;
  border-radius: 8px;
  padding: 4px;
}
</style>
